import { DialogActions } from '@material-ui/core';

import { bind } from 'bind-decorator';

import { Button, FlatButton } from 'bz-core-controls';

import type { IBaseProps } from 'bz-core-controls/modal-new/confirmation';
import React from 'react';

export interface IProps extends Pick<IBaseProps, 'actionProps'> {
  className: string;
  disabled?: boolean;
  disabledYes?: boolean;
  disabledNo?: boolean;
  yesLabel?: string;
  noLabel?: string;
  yesColor?: 'primary' | 'critical' | 'inherit' | 'default' | 'secondary';
  onYes: () => void;
  onNo: () => void;
}

class YesNoActions extends React.Component<IProps> {
  render() {
    const {
      actionProps,
      className,
      disabled,
      disabledYes,
      disabledNo,
      noLabel,
      yesColor,
      yesLabel
    } = this.props;

    return (
      <DialogActions {...actionProps} className={`${className} actions`}>
        <FlatButton
          className={`${className} btn-no`}
          disabled={disabledNo ?? disabled}
          label={noLabel ?? 'No'}
          secondary={true}
          onClick={this.onNo}
        />
        <Button
          variant="solid"
          className={`${className} btn-cancel`}
          disabled={disabledYes ?? disabled}
          primary={true}
          color={yesColor ?? actionProps?.yesColor ?? 'primary'}
          onClick={this.onYes}
        >
          {yesLabel ?? 'Yes'}
        </Button>
      </DialogActions>
    );
  }

  @bind
  private onYes(e: React.MouseEvent<any>): void {
    this.props.onYes();
  }

  @bind
  private onNo(e: React.MouseEvent<any>): void {
    this.props.onNo();
  }
}

export default YesNoActions;
